import { render, staticRenderFns } from "./FeatureTypeDetail.vue?vue&type=template&id=382b9ced&scoped=true"
import script from "./FeatureTypeDetail.vue?vue&type=script&lang=js"
export * from "./FeatureTypeDetail.vue?vue&type=script&lang=js"
import style0 from "./FeatureTypeDetail.vue?vue&type=style&index=0&id=382b9ced&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382b9ced",
  null
  
)

export default component.exports